import './App.css';
import React from 'react';
import RouterConfig from './RouterConfig.js';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://740ea8935ddcb4900469a04a33732643@o4507469526401024.ingest.de.sentry.io/4509167555903568',
});

function App() {
  return <RouterConfig />;
}

export default App;
